import { nonEmptyString } from '@atlassian/amkt-common';
import { makeAppKey } from '@atlassian/mpac-api-client';
import { Record } from 'immutable';
export const KEY_TYPE = 'KEY';
const URL_TYPE = 'URL';
export const ARI_TYPE = 'ARI';
export const makeInstallableAppByKeyIdentifier = Record({
  type: KEY_TYPE,
  key: makeAppKey('')
});
export const makeInstallableAppByAriIdentifier = Record({
  type: ARI_TYPE,
  ari: makeAppKey(''),
  appKey: makeAppKey('')
});
export const makeInstallableAppByUrlIdentifier = Record({
  type: URL_TYPE,
  url: nonEmptyString('url') // Invalid, but need a default
});
export function foldInstallableAppIdentifier(appIdentifier) {
  return function (key, url, ari) {
    switch (appIdentifier.type) {
      case KEY_TYPE:
        return key(appIdentifier);
      case URL_TYPE:
        return url(appIdentifier);
      case ARI_TYPE:
        return ari(appIdentifier);
      default:
        // Flow compile-time validation that we've handled every discover item
        // prettier-ignore
        appIdentifier;
        return undefined;
    }
  };
}
export const toSPIInstallableAddonIdentifier = appIdentifier => foldInstallableAppIdentifier(appIdentifier)(installableAppByKeyIdentifier => ({
  key: installableAppByKeyIdentifier.key
}), installableAppByUrlIdentifier => ({
  url: installableAppByUrlIdentifier.url
}), installableAppByAriIdentifier => ({
  ari: installableAppByAriIdentifier.ari,
  appKey: installableAppByAriIdentifier.appKey
}));